import axios from "axios";

const instance = axios.create();

// Set the request timeout in milliseconds
instance.defaults.timeout = 10000; // 10 seconds

export default instance;
